<app-navbar />
<div class="header-fix"></div>
<router-outlet />
<app-footer />
@if (showContactForm) {
  <app-contact-form (close)="closeContactForm()" [source]="contactFormSource" />
}
